import { render } from "./LegalNotices.vue?vue&type=template&id=184c3b65&scoped=true"
import script from "./LegalNotices.vue?vue&type=script&lang=js"
export * from "./LegalNotices.vue?vue&type=script&lang=js"

import "./LegalNotices.vue?vue&type=style&index=0&id=184c3b65&scoped=true&lang=scss"

import exportComponent from "C:\\projets\\rivha\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184c3b65"]])

export default __exports__